import styled from "styled-components"

export default {
    "Wrapper": styled.div`
        width: 100%;
        height: calc(100vh - 62px);
        display: flex;
    `,
    "ErrorDiv": styled.div`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 12px;

        & > h2 {
            ${({ theme }) => theme.font["xxlarge-semibold"]};
        }

        & > div {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 4px;

            & > p {
                ${({ theme }) => theme.font["medium-regular"]};
                color: ${({ theme }) => theme.color["grey4"]};
            }
        }
    `,

    "Video": styled.video`
        width: 100%;
        height: 100%;
        object-fit: cover;
    `,

    "Content": styled.div`
        width: 100%;
        max-width: 767px;
        height: 100%;
        position: fixed;
        top: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding-top: 80px;
        padding-bottom: calc(80px + 62px);
        overflow: hidden;
    `,
    "ScanDiv": styled.div`
        width: 80vw;
        max-width: 680px;
        height: 80vw;
        max-height: 680px;
        border: 3px solid ${({ theme }) => theme.color["gold"]};
        border-radius: 24px;
        box-shadow: 0 0 0 9999px rgb(0, 0, 0, 0.4);
    `,
    "ExplainDiv": styled.div`
        width: fit-content;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;

        & > p {
            ${({ theme }) => theme.font["medium-medium"]};
            color: ${({ theme }) => theme.color["white"]};
        }

        & > h2 {
            ${({ theme }) => theme.font["xlarge-bold"]};
            color: ${({ theme }) => theme.color["white"]};
        }
    `
}